import { useState } from "react";
import { motion } from "framer-motion";
import { Check, Plus, Expand } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { thumbUrl, previewUrl, brl } from "@/lib/api";
import { useCart } from "@/lib/cart";

export function PhotoGrid({ photos, event }) {
  const cart = useCart();
  const [zoom, setZoom] = useState(null);
  const item = (p) => ({ id: p.id, event_id: event.id, event_name: event.name, price: event.price, package_price: event.package_price });

  return (
    <>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2 sm:gap-3" data-testid="photo-grid">
        {photos.map((p, i) => {
          const sel = cart.has(p.id);
          return (
            <motion.div
              key={p.id}
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: Math.min(i * 0.03, 0.6) }}
              className={`group relative aspect-[4/5] overflow-hidden rounded-md bg-zinc-100 border-2 ${sel ? "border-[#0055FF]" : "border-transparent"}`}
              data-testid={`photo-item-${p.id}`}
            >
              <img src={thumbUrl(p.id)} alt="" loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
              <button
                onClick={() => setZoom(p)}
                data-testid={`photo-zoom-btn-${p.id}`}
                className="absolute top-2 left-2 w-9 h-9 rounded-md bg-white/80 backdrop-blur grid place-items-center"
              >
                <Expand className="w-4 h-4" />
              </button>
              <button
                onClick={() => cart.toggle(item(p))}
                data-testid={`photo-select-btn-${p.id}`}
                className={`absolute bottom-2 right-2 h-9 px-3 rounded-md flex items-center gap-1.5 text-sm font-semibold transition-colors ${sel ? "bg-[#0055FF] text-white" : "bg-white/90 text-zinc-900 hover:bg-white"}`}
              >
                {sel ? <Check className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                {sel ? "No carrinho" : brl(event.price)}
              </button>
            </motion.div>
          );
        })}
      </div>
      <Dialog open={!!zoom} onOpenChange={(o) => !o && setZoom(null)}>
        <DialogContent className="max-w-4xl p-2 bg-black border-0" data-testid="photo-zoom-dialog">
          <DialogTitle className="sr-only">Visualizar foto</DialogTitle>
          {zoom && (
            <>
              <img src={previewUrl(zoom.id)} alt="" className="w-full max-h-[78vh] object-contain" />
              <button
                onClick={() => cart.toggle(item(zoom))}
                data-testid="zoom-toggle-cart-btn"
                className="m-2 h-11 rounded-md bg-[#0055FF] hover:bg-[#0040CC] text-white font-semibold"
              >
                {cart.has(zoom.id) ? "Remover do carrinho" : `Adicionar ao carrinho · ${brl(event.price)}`}
              </button>
            </>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
